export const MEETING_REPO = 'MEETING_REPO';
export const MEETING_SERVICE = 'MEETING_SERVICE';
